<template>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="9" cy="8" r="3" stroke="currentColor" stroke-width="1.6"/>
<circle cx="17" cy="9" r="2.5" stroke="currentColor" stroke-width="1.6"/>
<path d="M3 20c0-3 2.5-5 6-5s6 2 6 5M14.5 15.3c2.8.2 4.5 1.9 4.8 4.7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
</svg>
</template>
